import React from 'react';
import { Alert } from '@mui/material';
import PageLayout from '../shell/PageLayout';
import { useOperations } from '../operations/OperationsProvider';
import { useZeny } from '../attention/ZenyProvider';
import ScopeFilters, { useScope, inDates } from '../operations/ScopeFilters';
import PerformanceCharts from '../operations/PerformanceCharts';
import DwellHeatmap from '../operations/DwellHeatmap';
import OperationsStatus from '../operations/OperationsStatus';

const AnalyticsPage = () => {
  const scope = useScope(); const { trips, data, speed, error } = useOperations(); const { items } = useZeny();
  const rows = trips.filter((t) => scope.matches(t));
  const issues = items.filter((i) => rows.some((t) => t.id === i.tripId) && inDates(i.occurredAt || i.raisedAt, scope.from, scope.to));
  return (
    <PageLayout title="Analytics" subtitle="Trip performance from recorded checkpoints and position samples.">
      <ScopeFilters scope={scope} />
      <OperationsStatus />
      {error ? <Alert severity="warning">Charts unavailable until data refreshes.</Alert> : (
        <>
          <PerformanceCharts trips={rows} issues={issues} config={data.config} speed={speed} />
          <DwellHeatmap trips={rows} />
        </>
      )}
    </PageLayout>
  );
};
export default AnalyticsPage;
